import { useState } from "react";

import { useAntenatalConsultations } from "features/pregnancy/hooks/useAntenatalConsultations";
import { formatDoctorName } from "features/pregnancy/utils/formatDoctorName";
import { formatDate } from "utils/dateFormatter.js";

export const usePregnancyGeneralViewState = (pregnancy) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { data: anteNatalConsultations } = useAntenatalConsultations(pregnancy.id);

  const firstConsultationDate = anteNatalConsultations?.at(0)?.consultationDate
    ? formatDate(anteNatalConsultations.at(0).consultationDate)
    : "No consultations found";

  const doctorName = formatDoctorName(pregnancy.conductedByStaffMember);

  return {
    isModalOpen,
    openModal: () => setIsModalOpen(true),
    closeModal: () => setIsModalOpen(false),
    firstConsultationDate,
    doctorName,
    /*
     * Handed back as well as read for the date, because the visits are the only place an ended
     * foetus survives: `pregnancy.foetuses` is an active-only read, so a baby recorded as not
     * continuing is found on the observations its visits carry (KIN-2066, findEndedFoetuses).
     */
    anteNatalConsultations,
  };
};
